import { UseCaseHero } from '@/components/use-cases/UseCaseHero';
import { UseCaseOverview } from '@/components/use-cases/UseCaseOverview';
import { UseCaseShowcase } from '@/components/use-cases/UseCaseShowcase';
import { QuoteDivider } from '@/components/use-cases/QuoteDivider';
import { FeatureCrossSection } from '@/components/use-cases/FeatureCrossSection';
import { UseCaseCTA } from '@/components/use-cases/UseCaseCTA';
import { PublicHeader } from '@/components/PublicHeader';
import { LandingFooter } from '@/components/landing/LandingFooter';
import { useEffect } from 'react';

export default function UseCasesPage() {
  useEffect(() => {
    document.title = 'Camp Use Cases | CampChef Pro – Built for Every Camp Kitchen';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'See how CampChef Pro helps youth camps, retreats, and outdoor programs streamline meal planning, inventory, and Sysco ordering.');
    }
    
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <PublicHeader />
      <main>
        <UseCaseHero />
        <UseCaseOverview />
        <UseCaseShowcase />
        <QuoteDivider />
        <FeatureCrossSection />
        <UseCaseCTA />
      </main>
      <LandingFooter />
    </div>
  );
}
